module.exports = [
	{
		"path": "3d-models",
		"name": "3D Models"
	},
	{
		"path": "cg-textures",
		"name": "CG Textures"
	},
	{
		"path": "materials-and-shaders",
		"name": "Materials & Shaders"
	},
	{
		"path": "scripts-and-plugins",
		"name": "Scripts & Plugins"
	},
	{
		"path": "2d-concepts",
		"name": "2D Concepts"
	},
	{
		"path": "animation-data",
		"name": "Animation Data"
	},
	{
		"path": "render-setups",
		"name": "Render Setups"
	}
];


//////////////////
// WEBPACK FOOTER
// ./config/sites/categories/3docean.json
// module id = 471
// module chunks = 1